import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import RenderPage from '../../../layouts/RenderPage';
import { selectLogin } from '../../../../store/login/loginSlice';

const iaChat = () => {
  const infoStateTemp = useSelector(selectLogin);
  // eslint-disable-next-line no-unused-vars
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });

  return (
    <RenderPage title="Ai Chat">
      <iframe
        src={infoState.iachat}
        width="100%"
        style={{ height: '100%', minHeight: '700px' }}
        frameBorder="0"></iframe>
    </RenderPage>
  );
};

export default iaChat;
